<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!--<transition name="fade" mode="out-in">-->

            <router-view></router-view>

    <!--</transition>-->
  </div>
</template>

<script>
export default {
  name: 'App',

  created(){
    if (sessionStorage.getItem("store") ) {
      this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  },
    beforeCreate(){
        let count = 0;
        let imgs = [
            //用require的方式添加图片地址，直接添加图片地址的话，在build打包之后会查找不到图片，因为打包之后的图片名称会有一个加密的字符串

        ]
        for (let img of imgs) {
            let image = new Image();
            image.src = img;
            image.onload = () => {
                count++;
            };
        }
    },
  methods: {

  }

}
</script>

<style>
  body {
    background-color: #ffffff;
    width: 100%;
    min-height:100%;
    font-size: 12px;
    -webkit-font-smoothing: antialiased;
    font-family: arial,sans-serif;
  }
/*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue


// WEBPACK FOOTER //
// src/App.vue